// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
___CSS_LOADER_EXPORT___.push([module.id, "@import url(https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap);"]);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Parent Progress Hub — theme-aware (light/dark via data-theme) */

.parent-hub-container {
  --ph-bg: var(--bg-color, #f1f5f9);
  --ph-ink: var(--text-color, #0f172a);
  --ph-muted: var(--text-secondary, #64748b);
  --ph-surface: var(--surface-color, #ffffff);
  --ph-border: var(--border-color, rgba(15, 23, 42, 0.1));
  --ph-accent: var(--brand-primary, #0877bc);
  --ph-accent-soft: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);
  --ph-warm: #ea8c2f;
  --ph-warm-soft: rgba(234, 140, 47, 0.16);
  --ph-sky: #0284c7;
  --ph-ok: #16a34a;
  --ph-ok-soft: rgba(22, 163, 74, 0.14);
  --ph-glow-a: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);
  --ph-glow-b: rgba(234, 140, 47, 0.08);
  --ph-shadow: rgba(15, 23, 42, 0.08);

  width: 100%;
  min-height: 100vh;
  background-color: var(--ph-bg);
  background-image:
    radial-gradient(at 0% 0%, var(--ph-glow-b) 0px, transparent 50%),
    radial-gradient(at 100% 100%, var(--ph-glow-a) 0px, transparent 50%);
  color: var(--ph-ink);
  font-family: "Outfit", var(--brand-font, system-ui), sans-serif;
  padding: 1.25rem 1rem 5rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
}

:root[data-theme="dark"] .parent-hub-container,
[data-theme="dark"] .parent-hub-container {
  --ph-bg: #0b0f19;
  --ph-ink: #f8fafc;
  --ph-muted: #94a3b8;
  --ph-surface: rgba(30, 41, 59, 0.72);
  --ph-border: rgba(255, 255, 255, 0.1);
  --ph-warm: #ffa451;
  --ph-warm-soft: rgba(255, 164, 81, 0.18);
  --ph-sky: #38bdf8;
  --ph-ok: #4ade80;
  --ph-ok-soft: rgba(34, 197, 94, 0.18);
  --ph-glow-a: rgba(59, 130, 246, 0.08);
  --ph-glow-b: rgba(255, 164, 81, 0.08);
  --ph-shadow: rgba(0, 0, 0, 0.35);
}

.parent-hub-shell {
  width: 100%;
  max-width: 840px;
  display: flex;
  flex-direction: column;
  gap: 1.5rem;
}

.parent-hub-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
  padding-bottom: 0.5rem;
  border-bottom: 1px solid var(--ph-border);
}

.parent-hub-header--brand {
  align-items: flex-start;
}

.parent-hub-brand {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  min-width: 0;
  flex: 1 1 220px;
}

.parent-hub-club-logo {
  flex-shrink: 0;
  width: 72px;
  height: 72px;
  border-radius: 18px;
  object-fit: contain;
  display: block;
  background: rgba(255, 255, 255, 0.92);
  padding: 4px;
  box-sizing: border-box;
  box-shadow: 0 8px 20px var(--ph-shadow);
}

.parent-hub-club-logo--fallback {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 1.65rem;
  font-weight: 800;
  color: var(--ph-accent);
  background: var(--ph-accent-soft);
}

.parent-hub-club-name {
  margin: 0.2rem 0 0 !important;
  font-weight: 600;
  color: var(--ph-accent) !important;
}

.parent-hub-title h1 {
  font-size: 1.5rem;
  font-weight: 800;
  margin: 0;
  color: var(--ph-ink);
  letter-spacing: -0.02em;
}

.parent-hub-title p {
  margin: 0.2rem 0 0;
  font-size: 0.88rem;
  color: var(--ph-muted);
}

.sibling-switcher-bar {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  overflow-x: auto;
  padding: 0.25rem 0;
  max-width: 100%;
}

.sibling-pill {
  display: flex;
  align-items: center;
  gap: 0.6rem;
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
  border-radius: 9999px;
  padding: 0.4rem 1rem 0.4rem 0.6rem;
  cursor: pointer;
  transition: all 0.2s ease;
  -webkit-user-select: none;
          user-select: none;
}

.sibling-pill:hover {
  border-color: var(--ph-warm);
}

.sibling-pill.active {
  background: var(--ph-warm-soft);
  border-color: var(--ph-warm);
  box-shadow: 0 0 16px var(--ph-warm-soft);
}

.sibling-pill-avatar {
  width: 28px;
  height: 28px;
  border-radius: 50%;
  background: var(--ph-warm);
  color: #0b0f19;
  font-weight: 700;
  font-size: 0.8rem;
  display: flex;
  align-items: center;
  justify-content: center;
  overflow: hidden;
  flex-shrink: 0;
}

.sibling-pill-avatar-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.sibling-pill-info {
  display: flex;
  flex-direction: column;
}

.sibling-pill-name {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--ph-ink);
}

.sibling-pill-sub {
  font-size: 0.7rem;
  color: var(--ph-muted);
}

.add-sibling-btn {
  background: transparent;
  border: 1px dashed var(--ph-border);
  border-radius: 9999px;
  padding: 0.4rem 0.85rem;
  color: var(--ph-muted);
  font-size: 0.8rem;
  font-weight: 600;
  cursor: pointer;
  display: flex;
  align-items: center;
  gap: 0.35rem;
  transition: all 0.2s ease;
  white-space: nowrap;
}

.add-sibling-btn:hover {
  border-color: var(--ph-warm);
  color: var(--ph-warm);
  background: var(--ph-warm-soft);
}

.parent-hero-card {
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
  border-radius: 20px;
  padding: 1.5rem;
  box-shadow: 0 12px 30px var(--ph-shadow);
  display: flex;
  flex-direction: column;
  gap: 1.25rem;
  position: relative;
  overflow: hidden;
}

.parent-hero-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-wrap: wrap;
  gap: 1rem;
}

.parent-hero-child {
  display: flex;
  align-items: center;
  gap: 1rem;
}

.parent-hero-avatar-wrap {
  width: 64px;
  height: 64px;
  border-radius: 50%;
  background: var(--ph-warm-soft);
  border: 2px solid var(--ph-warm);
  display: flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 0 20px var(--ph-warm-soft);
  position: relative;
  overflow: visible;
  flex-shrink: 0;
}

.parent-hero-avatar-wrap--photo {
  overflow: visible;
  cursor: pointer;
}

.parent-hero-avatar-img {
  width: 100%;
  height: 100%;
  border-radius: 50%;
  object-fit: cover;
}

.parent-hero-photo-btn {
  position: absolute;
  right: -2px;
  bottom: -2px;
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid var(--ph-border);
  background: var(--ph-surface);
  color: var(--ph-ink);
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  font-size: 14px;
  padding: 0;
  box-shadow: 0 4px 10px var(--ph-shadow);
}

.parent-hero-photo-btn:disabled {
  opacity: 0.6;
  cursor: not-allowed;
}

.parent-hero-photo-link {
  margin-top: 0.35rem;
  background: transparent;
  border: none;
  padding: 0;
  color: var(--ph-warm);
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  text-align: left;
}

.parent-hero-photo-link:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.parent-hero-details h2 {
  font-size: 1.35rem;
  font-weight: 800;
  margin: 0;
  color: var(--ph-ink);
}

.parent-hero-details p {
  margin: 0.25rem 0 0;
  font-size: 0.85rem;
  color: var(--ph-warm);
  font-weight: 600;
}

.parent-hero-path {
  display: flex;
  flex-direction: column;
  gap: 0.85rem;
}

.parent-hero-metrics {
  display: flex;
  gap: 1.5rem;
}

.hero-metric-item {
  display: flex;
  flex-direction: column;
  align-items: flex-end;
}

.hero-metric-item .val {
  font-size: 1.5rem;
  font-weight: 800;
  color: var(--ph-sky);
  line-height: 1;
}

.hero-metric-item .lbl {
  font-size: 0.75rem;
  color: var(--ph-muted);
  margin-top: 0.25rem;
}

.level-progress-wrap {
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.level-progress-header {
  display: flex;
  justify-content: space-between;
  gap: 0.75rem;
  font-size: 0.82rem;
  color: var(--ph-muted);
}

.level-progress-bar-bg {
  width: 100%;
  height: 10px;
  background: var(--ph-accent-soft);
  border-radius: 9999px;
  overflow: hidden;
}

.level-progress-bar-fill {
  height: 100%;
  background: linear-gradient(90deg, var(--ph-warm) 0%, var(--ph-sky) 100%);
  border-radius: 9999px;
  transition: width 0.5s ease;
}

.parent-medical-notes {
  margin-top: 0.25rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ph-border);
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.parent-medical-notes-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
}

.parent-medical-notes-header h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ph-ink);
}

.parent-medical-notes-saved {
  font-size: 0.75rem;
  font-weight: 700;
  color: var(--ph-ok);
}

.parent-medical-notes-help {
  margin: 0;
  font-size: 0.78rem;
  color: var(--ph-muted);
  line-height: 1.4;
}

.parent-medical-notes-input {
  width: 100%;
  box-sizing: border-box;
  resize: vertical;
  min-height: 4.5rem;
  border-radius: 12px;
  border: 1px solid var(--ph-border);
  background: color-mix(in srgb, var(--ph-surface) 80%, transparent);
  color: var(--ph-ink);
  padding: 0.7rem 0.85rem;
  font-size: 0.88rem;
  line-height: 1.4;
  font-family: inherit;
}

.parent-medical-notes-input:focus {
  outline: 2px solid color-mix(in srgb, var(--ph-warm) 55%, transparent);
  outline-offset: 1px;
}

.parent-medical-notes-actions {
  display: flex;
  justify-content: flex-end;
}

.parent-medical-notes-save {
  border: none;
  border-radius: 9999px;
  padding: 0.45rem 0.95rem;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  background: var(--ph-warm);
  color: #0b0f19;
}

.parent-medical-notes-save:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.parent-open-account {
  margin-top: 1rem;
  padding-top: 1rem;
  border-top: 1px solid var(--ph-border);
  display: flex;
  flex-direction: column;
  gap: 0.55rem;
}

.parent-open-account h3 {
  margin: 0;
  font-size: 0.95rem;
  font-weight: 700;
  color: var(--ph-ink);
}

.parent-open-account-help,
.parent-open-account--done p,
.parent-open-account-too-young {
  margin: 0;
  font-size: 0.82rem;
  line-height: 1.4;
  color: var(--ph-muted);
}

.parent-open-account-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.55rem;
  align-items: stretch;
}

.parent-open-account-input {
  flex: 1 1 12rem;
  min-width: 0;
  border: 1px solid var(--ph-border);
  border-radius: 10px;
  padding: 0.55rem 0.75rem;
  font-size: 0.88rem;
  background: var(--ph-surface, #fff);
  color: var(--ph-ink);
}

.parent-open-account-input:focus {
  outline: 2px solid color-mix(in srgb, var(--ph-warm, #ffa451) 55%, transparent);
  outline-offset: 1px;
}

.parent-open-account-cta {
  border: none;
  border-radius: 999px;
  padding: 0.5rem 0.95rem;
  font-size: 0.8rem;
  font-weight: 700;
  cursor: pointer;
  background: var(--ph-warm);
  color: #0b0f19;
  white-space: nowrap;
}

.parent-open-account-cta:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.parent-open-account-feedback {
  margin: 0;
  font-size: 0.8rem;
  line-height: 1.35;
}

.parent-open-account-feedback--ok {
  color: #15803d;
}

.parent-open-account-feedback--error {
  color: #b91c1c;
}

@media (max-width: 560px) {
  .parent-open-account-cta {
    width: 100%;
  }
}

.parent-hub-section {
  display: flex;
  flex-direction: column;
  gap: 0.9rem;
}

.parent-hub-section-title h3 {
  font-size: 1.1rem;
  font-weight: 700;
  margin: 0;
  color: var(--ph-ink);
}

.badges-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 0.85rem;
}

.badge-card {
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
  border-radius: 16px;
  padding: 1rem 0.85rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  gap: 0.4rem;
}

.badge-card.unearned {
  opacity: 0.45;
  filter: grayscale(80%);
}

.badge-icon {
  font-size: 2rem;
  margin-bottom: 0.25rem;
}

.badge-title {
  font-size: 0.88rem;
  font-weight: 700;
  color: var(--ph-ink);
}

.badge-desc {
  font-size: 0.72rem;
  color: var(--ph-muted);
  line-height: 1.25;
}

.sessions-list {
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}

.session-item-card {
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 1rem;
  flex-wrap: wrap;
}

.session-item-main {
  display: flex;
  align-items: center;
  gap: 0.85rem;
  flex: 1 1;
  min-width: 0;
}

.session-date-badge {
  background: var(--ph-accent-soft);
  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);
  border-radius: 10px;
  min-width: 3.4rem;
  padding: 0.4rem 0.55rem;
  text-align: center;
}

.session-date-badge .weekday {
  font-size: 0.62rem;
  font-weight: 700;
  letter-spacing: 0.06em;
  text-transform: uppercase;
  color: var(--ph-muted);
}

.session-date-badge .day {
  font-size: 1.2rem;
  font-weight: 800;
  color: var(--ph-sky);
  line-height: 1.05;
}

.session-date-badge .month {
  font-size: 0.68rem;
  color: var(--ph-muted);
  text-transform: uppercase;
}

.session-item-card--confirmed {
  border-color: color-mix(in srgb, var(--ph-ok) 45%, transparent);
}

.session-item-card--absent {
  border-color: color-mix(in srgb, #ef4444 40%, transparent);
}

.session-info {
  flex: 1 1;
  min-width: 0;
}

.session-info h4 {
  font-size: 0.95rem;
  font-weight: 700;
  margin: 0;
  color: var(--ph-ink);
}

.session-info p {
  font-size: 0.78rem;
  color: var(--ph-muted);
  margin: 0.2rem 0 0;
}

.session-rsvp-btn {
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
  color: var(--ph-ink);
  border-radius: 9999px;
  padding: 0.35rem 0.85rem;
  font-size: 0.78rem;
  font-weight: 700;
  cursor: pointer;
  white-space: nowrap;
}

.session-rsvp-actions {
  display: flex;
  flex-wrap: wrap;
  gap: 0.4rem;
  align-items: center;
  justify-content: flex-end;
}

.session-rsvp-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.session-rsvp-btn--present.is-active,
.session-rsvp-btn--present:hover {
  background: var(--ph-ok-soft);
  border-color: color-mix(in srgb, var(--ph-ok) 40%, transparent);
  color: var(--ph-ok);
}

.session-rsvp-btn--absent.is-active,
.session-rsvp-btn--absent:hover {
  background: color-mix(in srgb, #ef4444 14%, transparent);
  border-color: color-mix(in srgb, #ef4444 40%, transparent);
  color: #ef4444;
}

.session-rsvp-btn--clear {
  color: var(--ph-muted);
}

.session-rsvp-status {
  margin-top: 0.35rem !important;
  font-weight: 600;
}

.session-rsvp-status--confirmed {
  color: var(--ph-ok);
}

.session-rsvp-status--absent {
  color: #ef4444;
}

.session-rsvp-status--pending {
  color: var(--ph-muted);
}

.coach-note-card {
  background: var(--ph-warm-soft);
  border: 1px solid color-mix(in srgb, var(--ph-warm) 35%, transparent);
  border-radius: 14px;
  padding: 1rem 1.15rem;
  display: flex;
  flex-direction: column;
  gap: 0.4rem;
}

.coach-note-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  font-size: 0.82rem;
  color: var(--ph-warm);
  font-weight: 700;
}

.coach-note-text {
  font-size: 0.88rem;
  color: var(--ph-ink);
  line-height: 1.45;
}

.parent-hub-empty,
.parent-hub-empty-card {
  color: var(--ph-muted);
  font-size: 0.92rem;
  line-height: 1.45;
  margin: 0.5rem 0 0;
}

.parent-hub-empty-card {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 1rem;
  padding: 1.25rem 1.35rem;
  border-radius: 14px;
  background: var(--ph-surface);
  border: 1px solid var(--ph-border);
}

@media (max-width: 640px) {
  .parent-hero-top {
    flex-direction: column;
    align-items: flex-start;
  }
  .hero-metric-item {
    align-items: flex-start;
  }
  .parent-hub-club-logo {
    width: 64px;
    height: 64px;
    border-radius: 16px;
  }
  .session-item-card {
    flex-direction: column;
    align-items: flex-start;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/parent/ParentProgressHub.css"],"names":[],"mappings":"AAAA,kEAAkE;;AAIlE;EACE,iCAAiC;EACjC,oCAAoC;EACpC,0CAA0C;EAC1C,2CAA2C;EAC3C,uDAAuD;EACvD,0CAA0C;EAC1C,mEAAmE;EACnE,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,6DAA6D;EAC7D,qCAAqC;EACrC,mCAAmC;;EAEnC,WAAW;EACX,iBAAiB;EACjB,8BAA8B;EAC9B;;wEAEsE;EACtE,oBAAoB;EACpB,+DAA+D;EAC/D,0BAA0B;EAC1B,sBAAsB;EACtB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;;EAEE,gBAAgB;EAChB,iBAAiB;EACjB,mBAAmB;EACnB,oCAAoC;EACpC,qCAAqC;EACrC,kBAAkB;EAClB,wCAAwC;EACxC,iBAAiB;EACjB,gBAAgB;EAChB,qCAAqC;EACrC,qCAAqC;EACrC,qCAAqC;EACrC,gCAAgC;AAClC;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;EACT,sBAAsB;EACtB,yCAAyC;AAC3C;;AAEA;EACE,uBAAuB;AACzB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,cAAc;EACd,qCAAqC;EACrC,YAAY;EACZ,sBAAsB;EACtB,uCAAuC;AACzC;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,iCAAiC;AACnC;;AAEA;EACE,6BAA6B;EAC7B,gBAAgB;EAChB,kCAAkC;AACpC;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;EACpB,uBAAuB;AACzB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;EAChB,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,6BAA6B;EAC7B,kCAAkC;EAClC,qBAAqB;EACrB,kCAAkC;EAClC,eAAe;EACf,yBAAyB;EACzB,yBAAiB;UAAjB,iBAAiB;AACnB;;AAEA;EACE,4BAA4B;AAC9B;;AAEA;EACE,+BAA+B;EAC/B,4BAA4B;EAC5B,wCAAwC;AAC1C;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,0BAA0B;EAC1B,cAAc;EACd,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;AACxB;;AAEA;EACE,uBAAuB;EACvB,mCAAmC;EACnC,qBAAqB;EACrB,uBAAuB;EACvB,sBAAsB;EACtB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,4BAA4B;EAC5B,qBAAqB;EACrB,+BAA+B;AACjC;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,eAAe;EACf,wCAAwC;EACxC,aAAa;EACb,sBAAsB;EACtB,YAAY;EACZ,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,eAAe;EACf,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,+BAA+B;EAC/B,gCAAgC;EAChC,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,wCAAwC;EACxC,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,WAAW;EACX,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,kCAAkC;EAClC,6BAA6B;EAC7B,oBAAoB;EACpB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,eAAe;EACf,UAAU;EACV,uCAAuC;AACzC;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,uBAAuB;EACvB,YAAY;EACZ,UAAU;EACV,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,qBAAqB;AACvB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,YAAY;EACZ,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iCAAiC;EACjC,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,yEAAyE;EACzE,qBAAqB;EACrB,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,sBAAsB;EACtB,gBAAgB;EAChB,kBAAkB;EAClB,mBAAmB;EACnB,kCAAkC;EAClC,kEAAkE;EAClE,oBAAoB;EACpB,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,sEAAsE;EACtE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,YAAY;EACZ,qBAAqB;EACrB,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,sCAAsC;EACtC,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;;;EAGE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,YAAY;EACZ,kCAAkC;EAClC,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;EAClB,mCAAmC;EACnC,oBAAoB;AACtB;;AAEA;EACE,+EAA+E;EAC/E,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oBAAoB;EACpB,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,eAAe;EACf,0BAA0B;EAC1B,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,WAAW;EACb;AACF;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,YAAY;AACd;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,uBAAuB;EACvB,8BAA8B;EAC9B,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,YAAY;AACd;;AAEA;EACE,iCAAiC;EACjC,mEAAmE;EACnE,mBAAmB;EACnB,iBAAiB;EACjB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;AACxB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA;EACE,+DAA+D;AACjE;;AAEA;EACE,0DAA0D;AAC5D;;AAEA;EACE,SAAO;EACP,YAAY;AACd;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,sBAAsB;EACtB,kBAAkB;AACpB;;AAEA;EACE,6BAA6B;EAC7B,kCAAkC;EAClC,oBAAoB;EACpB,qBAAqB;EACrB,wBAAwB;EACxB,kBAAkB;EAClB,gBAAgB;EAChB,eAAe;EACf,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;;EAEE,6BAA6B;EAC7B,+DAA+D;EAC/D,mBAAmB;AACrB;;AAEA;;EAEE,wDAAwD;EACxD,0DAA0D;EAC1D,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,8BAA8B;EAC9B,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,+BAA+B;EAC/B,qEAAqE;EACrE,mBAAmB;EACnB,qBAAqB;EACrB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,oBAAoB;EACpB,iBAAiB;AACnB;;AAEA;;EAEE,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;EACjB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,SAAS;EACT,wBAAwB;EACxB,mBAAmB;EACnB,6BAA6B;EAC7B,kCAAkC;AACpC;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;EACA;IACE,uBAAuB;EACzB;EACA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;EACrB;EACA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;AACF","sourcesContent":["/* Parent Progress Hub — theme-aware (light/dark via data-theme) */\n\n@import url(\"https://fonts.googleapis.com/css2?family=Outfit:wght@400;500;600;700;800&display=swap\");\n\n.parent-hub-container {\n  --ph-bg: var(--bg-color, #f1f5f9);\n  --ph-ink: var(--text-color, #0f172a);\n  --ph-muted: var(--text-secondary, #64748b);\n  --ph-surface: var(--surface-color, #ffffff);\n  --ph-border: var(--border-color, rgba(15, 23, 42, 0.1));\n  --ph-accent: var(--brand-primary, #0877bc);\n  --ph-accent-soft: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.14);\n  --ph-warm: #ea8c2f;\n  --ph-warm-soft: rgba(234, 140, 47, 0.16);\n  --ph-sky: #0284c7;\n  --ph-ok: #16a34a;\n  --ph-ok-soft: rgba(22, 163, 74, 0.14);\n  --ph-glow-a: rgba(var(--brand-primary-rgb, 8, 119, 188), 0.1);\n  --ph-glow-b: rgba(234, 140, 47, 0.08);\n  --ph-shadow: rgba(15, 23, 42, 0.08);\n\n  width: 100%;\n  min-height: 100vh;\n  background-color: var(--ph-bg);\n  background-image:\n    radial-gradient(at 0% 0%, var(--ph-glow-b) 0px, transparent 50%),\n    radial-gradient(at 100% 100%, var(--ph-glow-a) 0px, transparent 50%);\n  color: var(--ph-ink);\n  font-family: \"Outfit\", var(--brand-font, system-ui), sans-serif;\n  padding: 1.25rem 1rem 5rem;\n  box-sizing: border-box;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n}\n\n:root[data-theme=\"dark\"] .parent-hub-container,\n[data-theme=\"dark\"] .parent-hub-container {\n  --ph-bg: #0b0f19;\n  --ph-ink: #f8fafc;\n  --ph-muted: #94a3b8;\n  --ph-surface: rgba(30, 41, 59, 0.72);\n  --ph-border: rgba(255, 255, 255, 0.1);\n  --ph-warm: #ffa451;\n  --ph-warm-soft: rgba(255, 164, 81, 0.18);\n  --ph-sky: #38bdf8;\n  --ph-ok: #4ade80;\n  --ph-ok-soft: rgba(34, 197, 94, 0.18);\n  --ph-glow-a: rgba(59, 130, 246, 0.08);\n  --ph-glow-b: rgba(255, 164, 81, 0.08);\n  --ph-shadow: rgba(0, 0, 0, 0.35);\n}\n\n.parent-hub-shell {\n  width: 100%;\n  max-width: 840px;\n  display: flex;\n  flex-direction: column;\n  gap: 1.5rem;\n}\n\n.parent-hub-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n  padding-bottom: 0.5rem;\n  border-bottom: 1px solid var(--ph-border);\n}\n\n.parent-hub-header--brand {\n  align-items: flex-start;\n}\n\n.parent-hub-brand {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  min-width: 0;\n  flex: 1 1 220px;\n}\n\n.parent-hub-club-logo {\n  flex-shrink: 0;\n  width: 72px;\n  height: 72px;\n  border-radius: 18px;\n  object-fit: contain;\n  display: block;\n  background: rgba(255, 255, 255, 0.92);\n  padding: 4px;\n  box-sizing: border-box;\n  box-shadow: 0 8px 20px var(--ph-shadow);\n}\n\n.parent-hub-club-logo--fallback {\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  font-size: 1.65rem;\n  font-weight: 800;\n  color: var(--ph-accent);\n  background: var(--ph-accent-soft);\n}\n\n.parent-hub-club-name {\n  margin: 0.2rem 0 0 !important;\n  font-weight: 600;\n  color: var(--ph-accent) !important;\n}\n\n.parent-hub-title h1 {\n  font-size: 1.5rem;\n  font-weight: 800;\n  margin: 0;\n  color: var(--ph-ink);\n  letter-spacing: -0.02em;\n}\n\n.parent-hub-title p {\n  margin: 0.2rem 0 0;\n  font-size: 0.88rem;\n  color: var(--ph-muted);\n}\n\n.sibling-switcher-bar {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  overflow-x: auto;\n  padding: 0.25rem 0;\n  max-width: 100%;\n}\n\n.sibling-pill {\n  display: flex;\n  align-items: center;\n  gap: 0.6rem;\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n  border-radius: 9999px;\n  padding: 0.4rem 1rem 0.4rem 0.6rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  user-select: none;\n}\n\n.sibling-pill:hover {\n  border-color: var(--ph-warm);\n}\n\n.sibling-pill.active {\n  background: var(--ph-warm-soft);\n  border-color: var(--ph-warm);\n  box-shadow: 0 0 16px var(--ph-warm-soft);\n}\n\n.sibling-pill-avatar {\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  background: var(--ph-warm);\n  color: #0b0f19;\n  font-weight: 700;\n  font-size: 0.8rem;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  overflow: hidden;\n  flex-shrink: 0;\n}\n\n.sibling-pill-avatar-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.sibling-pill-info {\n  display: flex;\n  flex-direction: column;\n}\n\n.sibling-pill-name {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--ph-ink);\n}\n\n.sibling-pill-sub {\n  font-size: 0.7rem;\n  color: var(--ph-muted);\n}\n\n.add-sibling-btn {\n  background: transparent;\n  border: 1px dashed var(--ph-border);\n  border-radius: 9999px;\n  padding: 0.4rem 0.85rem;\n  color: var(--ph-muted);\n  font-size: 0.8rem;\n  font-weight: 600;\n  cursor: pointer;\n  display: flex;\n  align-items: center;\n  gap: 0.35rem;\n  transition: all 0.2s ease;\n  white-space: nowrap;\n}\n\n.add-sibling-btn:hover {\n  border-color: var(--ph-warm);\n  color: var(--ph-warm);\n  background: var(--ph-warm-soft);\n}\n\n.parent-hero-card {\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n  border-radius: 20px;\n  padding: 1.5rem;\n  box-shadow: 0 12px 30px var(--ph-shadow);\n  display: flex;\n  flex-direction: column;\n  gap: 1.25rem;\n  position: relative;\n  overflow: hidden;\n}\n\n.parent-hero-top {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  flex-wrap: wrap;\n  gap: 1rem;\n}\n\n.parent-hero-child {\n  display: flex;\n  align-items: center;\n  gap: 1rem;\n}\n\n.parent-hero-avatar-wrap {\n  width: 64px;\n  height: 64px;\n  border-radius: 50%;\n  background: var(--ph-warm-soft);\n  border: 2px solid var(--ph-warm);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 0 20px var(--ph-warm-soft);\n  position: relative;\n  overflow: visible;\n  flex-shrink: 0;\n}\n\n.parent-hero-avatar-wrap--photo {\n  overflow: visible;\n  cursor: pointer;\n}\n\n.parent-hero-avatar-img {\n  width: 100%;\n  height: 100%;\n  border-radius: 50%;\n  object-fit: cover;\n}\n\n.parent-hero-photo-btn {\n  position: absolute;\n  right: -2px;\n  bottom: -2px;\n  width: 26px;\n  height: 26px;\n  border-radius: 50%;\n  border: 1px solid var(--ph-border);\n  background: var(--ph-surface);\n  color: var(--ph-ink);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  font-size: 14px;\n  padding: 0;\n  box-shadow: 0 4px 10px var(--ph-shadow);\n}\n\n.parent-hero-photo-btn:disabled {\n  opacity: 0.6;\n  cursor: not-allowed;\n}\n\n.parent-hero-photo-link {\n  margin-top: 0.35rem;\n  background: transparent;\n  border: none;\n  padding: 0;\n  color: var(--ph-warm);\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  text-align: left;\n}\n\n.parent-hero-photo-link:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.parent-hero-details h2 {\n  font-size: 1.35rem;\n  font-weight: 800;\n  margin: 0;\n  color: var(--ph-ink);\n}\n\n.parent-hero-details p {\n  margin: 0.25rem 0 0;\n  font-size: 0.85rem;\n  color: var(--ph-warm);\n  font-weight: 600;\n}\n\n.parent-hero-path {\n  display: flex;\n  flex-direction: column;\n  gap: 0.85rem;\n}\n\n.parent-hero-metrics {\n  display: flex;\n  gap: 1.5rem;\n}\n\n.hero-metric-item {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-end;\n}\n\n.hero-metric-item .val {\n  font-size: 1.5rem;\n  font-weight: 800;\n  color: var(--ph-sky);\n  line-height: 1;\n}\n\n.hero-metric-item .lbl {\n  font-size: 0.75rem;\n  color: var(--ph-muted);\n  margin-top: 0.25rem;\n}\n\n.level-progress-wrap {\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.level-progress-header {\n  display: flex;\n  justify-content: space-between;\n  gap: 0.75rem;\n  font-size: 0.82rem;\n  color: var(--ph-muted);\n}\n\n.level-progress-bar-bg {\n  width: 100%;\n  height: 10px;\n  background: var(--ph-accent-soft);\n  border-radius: 9999px;\n  overflow: hidden;\n}\n\n.level-progress-bar-fill {\n  height: 100%;\n  background: linear-gradient(90deg, var(--ph-warm) 0%, var(--ph-sky) 100%);\n  border-radius: 9999px;\n  transition: width 0.5s ease;\n}\n\n.parent-medical-notes {\n  margin-top: 0.25rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ph-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.parent-medical-notes-header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n}\n\n.parent-medical-notes-header h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ph-ink);\n}\n\n.parent-medical-notes-saved {\n  font-size: 0.75rem;\n  font-weight: 700;\n  color: var(--ph-ok);\n}\n\n.parent-medical-notes-help {\n  margin: 0;\n  font-size: 0.78rem;\n  color: var(--ph-muted);\n  line-height: 1.4;\n}\n\n.parent-medical-notes-input {\n  width: 100%;\n  box-sizing: border-box;\n  resize: vertical;\n  min-height: 4.5rem;\n  border-radius: 12px;\n  border: 1px solid var(--ph-border);\n  background: color-mix(in srgb, var(--ph-surface) 80%, transparent);\n  color: var(--ph-ink);\n  padding: 0.7rem 0.85rem;\n  font-size: 0.88rem;\n  line-height: 1.4;\n  font-family: inherit;\n}\n\n.parent-medical-notes-input:focus {\n  outline: 2px solid color-mix(in srgb, var(--ph-warm) 55%, transparent);\n  outline-offset: 1px;\n}\n\n.parent-medical-notes-actions {\n  display: flex;\n  justify-content: flex-end;\n}\n\n.parent-medical-notes-save {\n  border: none;\n  border-radius: 9999px;\n  padding: 0.45rem 0.95rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--ph-warm);\n  color: #0b0f19;\n}\n\n.parent-medical-notes-save:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.parent-open-account {\n  margin-top: 1rem;\n  padding-top: 1rem;\n  border-top: 1px solid var(--ph-border);\n  display: flex;\n  flex-direction: column;\n  gap: 0.55rem;\n}\n\n.parent-open-account h3 {\n  margin: 0;\n  font-size: 0.95rem;\n  font-weight: 700;\n  color: var(--ph-ink);\n}\n\n.parent-open-account-help,\n.parent-open-account--done p,\n.parent-open-account-too-young {\n  margin: 0;\n  font-size: 0.82rem;\n  line-height: 1.4;\n  color: var(--ph-muted);\n}\n\n.parent-open-account-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.55rem;\n  align-items: stretch;\n}\n\n.parent-open-account-input {\n  flex: 1 1 12rem;\n  min-width: 0;\n  border: 1px solid var(--ph-border);\n  border-radius: 10px;\n  padding: 0.55rem 0.75rem;\n  font-size: 0.88rem;\n  background: var(--ph-surface, #fff);\n  color: var(--ph-ink);\n}\n\n.parent-open-account-input:focus {\n  outline: 2px solid color-mix(in srgb, var(--ph-warm, #ffa451) 55%, transparent);\n  outline-offset: 1px;\n}\n\n.parent-open-account-cta {\n  border: none;\n  border-radius: 999px;\n  padding: 0.5rem 0.95rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  cursor: pointer;\n  background: var(--ph-warm);\n  color: #0b0f19;\n  white-space: nowrap;\n}\n\n.parent-open-account-cta:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n.parent-open-account-feedback {\n  margin: 0;\n  font-size: 0.8rem;\n  line-height: 1.35;\n}\n\n.parent-open-account-feedback--ok {\n  color: #15803d;\n}\n\n.parent-open-account-feedback--error {\n  color: #b91c1c;\n}\n\n@media (max-width: 560px) {\n  .parent-open-account-cta {\n    width: 100%;\n  }\n}\n\n.parent-hub-section {\n  display: flex;\n  flex-direction: column;\n  gap: 0.9rem;\n}\n\n.parent-hub-section-title h3 {\n  font-size: 1.1rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--ph-ink);\n}\n\n.badges-grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));\n  gap: 0.85rem;\n}\n\n.badge-card {\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n  border-radius: 16px;\n  padding: 1rem 0.85rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  text-align: center;\n  gap: 0.4rem;\n}\n\n.badge-card.unearned {\n  opacity: 0.45;\n  filter: grayscale(80%);\n}\n\n.badge-icon {\n  font-size: 2rem;\n  margin-bottom: 0.25rem;\n}\n\n.badge-title {\n  font-size: 0.88rem;\n  font-weight: 700;\n  color: var(--ph-ink);\n}\n\n.badge-desc {\n  font-size: 0.72rem;\n  color: var(--ph-muted);\n  line-height: 1.25;\n}\n\n.sessions-list {\n  display: flex;\n  flex-direction: column;\n  gap: 0.75rem;\n}\n\n.session-item-card {\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n  border-radius: 14px;\n  padding: 1rem 1.15rem;\n  display: flex;\n  align-items: flex-start;\n  justify-content: space-between;\n  gap: 1rem;\n  flex-wrap: wrap;\n}\n\n.session-item-main {\n  display: flex;\n  align-items: center;\n  gap: 0.85rem;\n  flex: 1;\n  min-width: 0;\n}\n\n.session-date-badge {\n  background: var(--ph-accent-soft);\n  border: 1px solid rgba(var(--brand-primary-rgb, 8, 119, 188), 0.28);\n  border-radius: 10px;\n  min-width: 3.4rem;\n  padding: 0.4rem 0.55rem;\n  text-align: center;\n}\n\n.session-date-badge .weekday {\n  font-size: 0.62rem;\n  font-weight: 700;\n  letter-spacing: 0.06em;\n  text-transform: uppercase;\n  color: var(--ph-muted);\n}\n\n.session-date-badge .day {\n  font-size: 1.2rem;\n  font-weight: 800;\n  color: var(--ph-sky);\n  line-height: 1.05;\n}\n\n.session-date-badge .month {\n  font-size: 0.68rem;\n  color: var(--ph-muted);\n  text-transform: uppercase;\n}\n\n.session-item-card--confirmed {\n  border-color: color-mix(in srgb, var(--ph-ok) 45%, transparent);\n}\n\n.session-item-card--absent {\n  border-color: color-mix(in srgb, #ef4444 40%, transparent);\n}\n\n.session-info {\n  flex: 1;\n  min-width: 0;\n}\n\n.session-info h4 {\n  font-size: 0.95rem;\n  font-weight: 700;\n  margin: 0;\n  color: var(--ph-ink);\n}\n\n.session-info p {\n  font-size: 0.78rem;\n  color: var(--ph-muted);\n  margin: 0.2rem 0 0;\n}\n\n.session-rsvp-btn {\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n  color: var(--ph-ink);\n  border-radius: 9999px;\n  padding: 0.35rem 0.85rem;\n  font-size: 0.78rem;\n  font-weight: 700;\n  cursor: pointer;\n  white-space: nowrap;\n}\n\n.session-rsvp-actions {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.4rem;\n  align-items: center;\n  justify-content: flex-end;\n}\n\n.session-rsvp-btn:disabled {\n  opacity: 0.55;\n  cursor: not-allowed;\n}\n\n.session-rsvp-btn--present.is-active,\n.session-rsvp-btn--present:hover {\n  background: var(--ph-ok-soft);\n  border-color: color-mix(in srgb, var(--ph-ok) 40%, transparent);\n  color: var(--ph-ok);\n}\n\n.session-rsvp-btn--absent.is-active,\n.session-rsvp-btn--absent:hover {\n  background: color-mix(in srgb, #ef4444 14%, transparent);\n  border-color: color-mix(in srgb, #ef4444 40%, transparent);\n  color: #ef4444;\n}\n\n.session-rsvp-btn--clear {\n  color: var(--ph-muted);\n}\n\n.session-rsvp-status {\n  margin-top: 0.35rem !important;\n  font-weight: 600;\n}\n\n.session-rsvp-status--confirmed {\n  color: var(--ph-ok);\n}\n\n.session-rsvp-status--absent {\n  color: #ef4444;\n}\n\n.session-rsvp-status--pending {\n  color: var(--ph-muted);\n}\n\n.coach-note-card {\n  background: var(--ph-warm-soft);\n  border: 1px solid color-mix(in srgb, var(--ph-warm) 35%, transparent);\n  border-radius: 14px;\n  padding: 1rem 1.15rem;\n  display: flex;\n  flex-direction: column;\n  gap: 0.4rem;\n}\n\n.coach-note-header {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  font-size: 0.82rem;\n  color: var(--ph-warm);\n  font-weight: 700;\n}\n\n.coach-note-text {\n  font-size: 0.88rem;\n  color: var(--ph-ink);\n  line-height: 1.45;\n}\n\n.parent-hub-empty,\n.parent-hub-empty-card {\n  color: var(--ph-muted);\n  font-size: 0.92rem;\n  line-height: 1.45;\n  margin: 0.5rem 0 0;\n}\n\n.parent-hub-empty-card {\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  gap: 1rem;\n  padding: 1.25rem 1.35rem;\n  border-radius: 14px;\n  background: var(--ph-surface);\n  border: 1px solid var(--ph-border);\n}\n\n@media (max-width: 640px) {\n  .parent-hero-top {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  .hero-metric-item {\n    align-items: flex-start;\n  }\n  .parent-hub-club-logo {\n    width: 64px;\n    height: 64px;\n    border-radius: 16px;\n  }\n  .session-item-card {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
